import {FC} from 'react'
import DashboardNew from './DashboardNew'

const DashboardNewWrapper: FC = () => {
  return <DashboardNew />
}

export {DashboardNewWrapper}
